import { arrange } from "./shared/utils/utils";

class AsyncStorage {
  // Async getItem method
  static async getItem(key) {
    return localStorage.getItem(key);
  }

  // Async setItem method
  static async setItem(key, value) {
    return localStorage.setItem(key, value);
  }

  // Async removeItem method
  static async removeItem(key) {
    return localStorage.removeItem(key);
  }

  // Async clear method
  static async clear() {
    return localStorage.clear();
  }

  static async multiRemove(keys) {
    keys.forEach((key) => {
      localStorage.removeItem(key);
    });
  }

  static async getAllKeys() {
    return arrange(localStorage.length).map((i) => localStorage.key(i));
  }
}

export default AsyncStorage;
